import { App, Button, Card, Col, Input, message, Modal, Pagination, Popconfirm, Row, Select, Space, Spin, Table, Tag, Upload, } from "antd";
import { Option } from "antd/es/mentions";
import { CheckOutlined, CloseOutlined, EyeFilled, LoadingOutlined, UploadOutlined, LeftOutlined, RightOutlined, TeamOutlined, SafetyCertificateOutlined, WarningOutlined, LineChartOutlined, RiseOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BULK_ADD_USER, LIST_USER, USER_STATUS, BULD_USER_IMPORT_TEMPLATE, LIST_DEPARTMENTS, USER_SUMMARY } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import UserCard from "./UserCard";


function Users() {
  const { notification } = App.useApp();
  const [page_size, set_page_size] = useState(9);
  const debounceRef = useRef(null);
  const departmentRef = useRef(null);

  const [low_risk, set_low_risk] = useState("");
  const [avg_score, set_avg_score] = useState("");
  const [high_risk, set_high_risk] = useState("");

  const [summary_total_users, set_summary_total_users] = useState(0);
  const [pagination_total_users, set_pagination_total_users] = useState(0);



  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");


  //USE STATE FOR PAGINATION AND LOADER
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("user_page")) || 1
  );
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");
  const [onchange_call, set_onchange_call] = useState(true);
  const [errors, set_errors] = useState("");

  // fillter state
  const [search_query_key, set_search_query_key] = useState(
    localStorage.getItem("user_search_key") || "name"
  );

  const [search_query_value, set_search_query_value] = useState(
    localStorage.getItem("user_search") || ""
  );

  const [file, set_file] = useState([]);
  const [is_model_open, set_is_model_open] = useState(false);


  const handleDownloadTemplate = async () => {
    try {
      const response = await BULD_USER_IMPORT_TEMPLATE();

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "bulk_import_user_template.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();

      notification.success({
        message: "Template Downloaded",
        description: "Excel template downloaded successfully",
      });
    } catch (error) {
      notification.error({
        message: "Download Failed",
        description: "Something went wrong",
      });
    }
  };

  const showModal = () => {
    set_is_model_open(true);
  };


  const handleCancel = () => {
    set_is_model_open(false);
  };

  const beforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {

      return Upload.LIST_IGNORE;
    }

    set_file([file]);
    message.success(` ${file.name}`);
    return false;
  };

  const getDepartments = async () => {
    try {
      const response = await LIST_DEPARTMENTS();

      if (response?.data?.status) {
        setDepartmentList(response?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const USER_SUMMARY_LIST = async () => {
    try {
      const API_CALL = await USER_SUMMARY();

      if (API_CALL?.data?.status) {
        const summary = API_CALL?.data?.data;

        set_summary_total_users(summary?.total_users || 0);
        set_low_risk(summary?.low_risk_users || 0);
        set_high_risk(summary?.high_risk_users || 0);
        set_avg_score(summary?.average_score || 0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    USER_SUMMARY_LIST();
  }, []);


  const fetchResults = useCallback((search_key, search_value) => {
    debounce(async () => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("page", 1);
        FORM_DATA.append("per_page", page_size);
        FORM_DATA.append(search_key, search_value);
        const API_CALL = await LIST_USER(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_table_data(API_CALL?.data?.data);
          set_current_page(1);
          localStorage.setItem("user_page", 1);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_users(API_CALL?.data?.total_users);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500)(); // Call debounce immediately
  }, [page_size]);

  const scrollLeft = () => {
    departmentRef.current?.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    departmentRef.current?.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  const LIST_API = async (
    page = current_page,
    size = page_size,
    key = search_query_key,
    value = search_query_value,
    department_id = selectedDepartment
  ) => {
    try {
      setLoader(true);

      const FORM_DATA = new FormData();

      FORM_DATA.append("page", page);
      FORM_DATA.append("per_page", size);


      if (value) {
        FORM_DATA.append(key, value);
      }
      if (department_id) {
        FORM_DATA.append("department", department_id);
      }

      const API_CALL = await LIST_USER(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_table_data(API_CALL?.data?.data || []);
        set_total_pages(API_CALL?.data?.total_pages || 0);
        set_total_users(API_CALL?.data?.total_users || 0);
        set_current_page(API_CALL?.data?.current_page || page);

      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      set_pagination_loader(false);
    }
  };

  useEffect(() => {
    getDepartments();

    LIST_API(
      Number(localStorage.getItem("user_page")) || 1,
      page_size,
      localStorage.getItem("user_search_key") || "name",
      localStorage.getItem("user_search") || ""
    );
  }, []);

  const change_status = async (id) => {
    setLoader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    try {
      const response = await USER_STATUS(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        await LIST_API(current_page, page_size);
      }

    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    } finally {
      setLoader(false);
    }
  };

  const selectBefore = (
    <Select
      value={
        search_query_key === "name"
          ? "Name"
          : search_query_key === "email"
            ? "Email"
            : "Phone"
      }
      onChange={(value) => {

        const key =
          value === "Name"
            ? "name"
            : value === "Email"
              ? "email"
              : "contact_no";

        set_search_query_key(key);

        localStorage.setItem(
          "user_search_key",
          key
        );

        LIST_API(
          current_page,
          page_size,
          key,
          search_query_value
        );
      }}
    >
      <Option value="Name">Name</Option>
      <Option value="Email">Email</Option>
      <Option value="Phone">Phone</Option>
    </Select>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record.name}
        </span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => <span>{record.email}</span>,
    },
    {
      title: "Phone",
      dataIndex: "contact_no",
      render: (text, record) => <span>{record.contact_no || "No Data"}</span>,
    },
    {
      title: "Status",
      key: "status",
      render: (text, record) => (
        <span>
          {record.status ? (
            <>
              <Tag color="#1fa7a1" style={{ fontSize: "14px", padding: "4px 9px" }}>Active</Tag>
            </>
          ) : (
            <>
              <Tag color="error" style={{ fontSize: "14px", padding: "4px 9px" }}
              >Inactive</Tag>
            </>
          )}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button type="primary" size="small" onClick={() => navigate("/edit-user/" + btoa(record.id))}><EyeFilled /></Button>
          <Button type="primary" size="small" onClick={() => navigate("/users-camp/" + btoa(record.id))}>Camp</Button>
          <Popconfirm
            title="Are you sure to change status?"
            onConfirm={() => change_status(record?.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              size="small"
              style={{
                backgroundColor: record.status ? "#52c41a" : "#ff4d4f",
                borderColor: record.status ? "#52c41a" : "#ff4d4f",
                color: "#fff"
              }}
              icon={
                record.status ? <CheckOutlined /> : <CloseOutlined />
              }
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const pagination_on_change = async (page, size) => {
    localStorage.setItem("user_page", page);

    set_pagination_loader(true);

    await LIST_API(
      page,
      size,
      search_query_key,
      search_query_value
    );

    set_pagination_loader(false);
  };



  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_value) {
      localStorage.setItem(
        "user_last_search_page",
        current_page
      );
    }

    set_search_query_value(value);

    localStorage.setItem(
      "user_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "user_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        page_size,
        search_query_key,
        value
      );

    }, 500);
  };



  const handleBulkUpload = async () => {

    const formData = new FormData();
    formData.append("file", file[0]);

    try {
      const response = await BULK_ADD_USER(formData);
      if (response?.data?.status) {
        const tracking_id = response?.data?.import_tracking_id;
        set_is_model_open(false);
        if (tracking_id) {
          localStorage.setItem("user_page", current_page);
          navigate("/imported-users/" + btoa(tracking_id));
        }

      } else {
        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    }
  };


  return (
    <div className="lms-body">



      <Row>
        <Col span={12}>
          <h2>Users</h2>
        </Col>
        <Col span={12}>

          <div style={{ float: "right" }}>
            <Button
              color="cyan"
              variant="solid"
              onClick={handleDownloadTemplate}
              style={{ marginRight: "6px" }}
            >
              Download Template
            </Button>
            <Button
              type="primary"
              onClick={() => {

                localStorage.setItem(
                  "user_search",
                  search_query_value
                );

                localStorage.setItem(
                  "user_search_key",
                  search_query_key
                );

                localStorage.setItem(
                  "user_page",
                  current_page
                );

                navigate("/add-user");
              }}
            >
              Add User
            </Button>


            <Button color="cyan" variant="solid" onClick={showModal} onCancel={handleCancel} style={{ marginLeft: "6px" }}>Import Users</Button>

            {/* <Button
              color="danger"
              variant="solid"
              style={{ marginLeft: "5px" }}
            >
              Export Users             </Button> */}
          </div>
        </Col>
      </Row>

      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px",
                }}
              >
                <TeamOutlined style={{ color: "blue", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{summary_total_users}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Users
                </span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#d1fae5",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px",
                }}
              >
                <SafetyCertificateOutlined
                  style={{ color: "#1fa7a1", fontSize: 18 }}
                />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{low_risk}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Low Risks
                </span>
              </div>
            </div>
          </Card>
        </Col>

        {/* Insider Risk */}
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#f0914d68",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px",
                }}
              >
                <WarningOutlined style={{ color: "red", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{high_risk}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  High Risk
                </span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#fffed2",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px",
                }}
              >
                <RiseOutlined style={{  color: "#F5A623", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{avg_score}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Avg Score
                </span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Card>
        <Row align="middle" gutter={16} wrap={false}>
          <Col flex="400px">
            <Input
              addonBefore={selectBefore}
              placeholder="Search by name"
              value={search_query_value}
              onChange={handleInput}
              size="large"
            />
          </Col>

          <Col flex="auto">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button
                size="small"
                icon={<LeftOutlined />}
                onClick={scrollLeft}

              />

              <div
                ref={departmentRef}
                style={{
                  overflow: "hidden",
                  flex: 1,
                  margin: "0 8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Button
                    type={selectedDepartment === "" ? "primary" : "default"}
                    onClick={() => {
                      setSelectedDepartment("");
                      LIST_API(
                        1,
                        page_size,
                        search_query_key,
                        search_query_value,
                        ""
                      );
                    }}
                    style={{
                      height: "23px",
                      width: "20px",

                    }}
                  >
                    All
                  </Button>

                  {departmentList?.map((dept) => (
                    <Button
                      key={dept}
                      type={selectedDepartment === dept ? "primary" : "default"}
                      onClick={() => {
                        setSelectedDepartment(dept);

                        LIST_API(
                          1,
                          page_size,
                          search_query_key,
                          search_query_value,
                          dept
                        );
                      }}
                      style={{
                        height: "23px",
                        padding: "0 10px",
                        fontSize: "12px",
                      }}
                    >
                      {dept}
                    </Button>
                  ))}
                </div>
              </div>

              <Button
                size="small"
                icon={<RightOutlined />}
                onClick={scrollRight}
              />
            </div>
          </Col>
        </Row>
        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Row gutter={[16, 16]} style={{ marginTop: "15px" }}>
                  {table_data?.map((user, index) => (
                    <Col xs={24} sm={12} md={8} lg={8} key={index}>
                      <UserCard
                        user={{
                          ...user,
                          risk_score: user?.risk_score,
                          risk_label: user?.risk_label || "Low Risk",
                          susceptibility: user?.susceptibility,
                          training: user?.training || 95,
                          reporting: user?.reporting || 85,
                        }}
                        current_page={current_page}
                        search_query_value={search_query_value}
                        search_query_key={search_query_key}
                        onChangeStatus={change_status}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div style={{ float: "right", marginTop: "20px" }}>
                  {" "}
                  <Pagination
                    current={current_page}
                    total={total_users}
                    pageSize={page_size}
                    showSizeChanger
                    pageSizeOptions={['9', '18', '27', '36', '45', '54', '72', '90']}
                    onChange={pagination_on_change}
                    onShowSizeChange={(current, size) => {
                      localStorage.setItem("user_page", 1);

                      set_page_size(size);
                      set_current_page(1);

                      pagination_on_change(1, size);
                    }}
                    style={{ display: "inline-block" }}
                    className="no-search-pagination"
                  />

                  <style>
                    {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                  </style>

                </div>
              </>
            ) : (
              <>

              </>
            )}
          </>
        )}

        <Modal

          title="Import Users"
          open={is_model_open}
          onCancel={handleCancel}
          footer={[
            <Button color="green" variant="solid" onClick={handleBulkUpload} style={{ width: "100%" }}>
              Add
            </Button>,
          ]}
          width={400}
        >
          <div style={{ width: "100%" }}>
            <Upload
              beforeUpload={beforeUpload}
              file={file}
              onRemove={() => set_file([])}
              accept=".csv"
              style={{ width: "100%" }} // optional
            >
              <div style={{ width: "100%" }}>
                <Button type="primary" icon={<UploadOutlined />} block>
                  Upload File
                </Button>
              </div>
            </Upload>
            {errors?.file ? (
              <>
                <span style={{ color: "red" }}>
                  {errors?.file}
                </span>
              </>
            ) : (
              <></>
            )}
          </div>
        </Modal>

      </Card>
    </div>
  );
}

export default Users;
